import * as Diagram from "../../../../components/diagram";

export const AD8List = {
  label: "AD8(總分>=2)名單",
  key: "AD8List",
  path: "ElderlyHealth/AD8List",
  api: "TCS_V_OHCheckItems01V",
  render: (options) => <Diagram.ElderlyHealth.AD8List {...options} />,
  isRaw: true,
  isPage: true,
  page: null,
  filterColumns: [{ key: "篩檢年份", type: "string" }],
  columns: [
    {
      key: "CaseID",
      field: "CaseID",
      header: "案件編號",
    },
    {
      key: "PID",
      field: "PID",
      header: "身分證",
    },
    {
      key: "Name",
      field: "Name",
      header: "個案姓名",
    },
    {
      key: "Address",
      field: "Address",
      header: "地址",
    },
    {
      key: "Phone",
      field: "Phone",
      header: "電話",
    },
    {
      key: "篩檢年份",
      field: "篩檢年份",
      header: "篩檢年份",
    },
    {
      key: "AD8",
      field: "AD8",
      header: "總分",
    },
  ],
};
